import React from 'react';
import { sanitizeCalculToString } from '../../helpers/number/sanitizeCalul';
import { CommandDetailLine } from 'components/atoms/Texts/CommandDetailLine';
import { CommandeDef } from '../../types/commande/commande.def';
import {
  formatCommandStatus,
  formatCommandMethodePaiement
} from 'helpers/commande/formatCommand';

const HeaderSingleProduct = ({
  commande,
  variant = 'default'
}: {
  commande: CommandeDef;
  variant?: 'default' | 'recapCommande';
}) => {
  if (!commande.client)
    return (
      <p style={{ color: '#D12C3F', marginBottom: '10px', marginTop: '10px' }}>
        Le client n'est pas renseigné, veuillez contacter un responsable pour
        modifier votre commande
      </p>
    );
  const totalPrice = sanitizeCalculToString(commande.totalttc);
  const fraisLivraison = sanitizeCalculToString(commande.fraislivraison);

  return (
    <div>
      <CommandDetailLine
        variant={variant}
        withDivider={true}
        title="Numéro de commande :"
        text={commande.numerocommande}
      />
      <CommandDetailLine
        variant={variant}
        withDivider={true}
        title="Prix de la commande (hors frais livraison et ONG) :"
        text={totalPrice + ' €'}
      />
      <CommandDetailLine
        variant={variant}
        withDivider={true}
        title="Frais de livraison :"
        text={fraisLivraison + ' €'}
      />
      <CommandDetailLine
        variant={variant}
        withDivider={true}
        title="Contribution ONG :"
        text={commande.customerContributedToTheOng ? '1€' : '0€'}
      />
      <CommandDetailLine
        variant={variant}
        withDivider={true}
        title="Total à payer (avec frais livraison et ONG) :"
        text={commande.prixTotal + ' €'}
      />
      <CommandDetailLine
        variant={variant}
        withDivider={true}
        title="Payé :"
        text={commande.status === 'PAYE' ? 'OUI' : 'NON'}
      />
      <CommandDetailLine
        variant={variant}
        withDivider={true}
        title="Statut de la commande :"
        text={formatCommandStatus(commande.status)}
      />
      <CommandDetailLine
        variant={variant}
        title="Méthode de paiement :"
        text={formatCommandMethodePaiement(commande.methodepaiement)}
      />
    </div>
  );
};
export default HeaderSingleProduct;
